import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    OperatingHours, OperationalDays,
} from 'app/enums/label.enums'
import {
    WorkSchedule,
} from '../Gateways.types'

export default ({
    isAllDay,
    getAllowedValues,
}: {
    isAllDay: boolean,
    getAllowedValues: (val: Record<string, string>) => Record<string, string>
}): DTOCardFormField<keyof WorkSchedule>[] => {
    return [{
        id: 'workSchedule',
        title: 'Settings',
        fields: [
            {
                name: 'operatingDays',
                componentName: 'EnumSelector',
                className: 'operatingDays',
                useDropdown: true,
                allowedValues: getAllowedValues(OperationalDays),
                required: true,
                labelKey: 'OPERATIONAL_DAYS',
            },
            {
                name: 'operatingHours',
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(OperatingHours),
                required: true,
                labelKey: 'OPERATING_HOURS',
            },
            {
                name: 'workStartsAt',
                componentName: 'TimePicker',
                disabled: isAllDay,
                defaultValue: isAllDay ? '00:00' : undefined,
                required: true,
                labelKey: 'STARTS_AT',
            },
            {
                name: 'workEndsAt',
                componentName: 'TimePicker',
                disabled: isAllDay,
                defaultValue: isAllDay ? '23:59' : undefined,
                required: true,
                labelKey: 'ENDS_AT',
            },
        ],
    }]
}
